<template lang="pug">

main
  section.intro
    .card.feature
      ad-featured
    .card.feature.featured2
      ad-featured

  isotope(ref="cpt" id="root_isotope1" :item-selector="'element-item'" :list="cities" :options='option' v-images-loaded:on.progress="layout" @filter="filterOption=arguments[0]")
    bems-place-card(v-if="!city.status" v-for="city in cities" key="city['.key']" :city="city")
  search-n-filter
    p Categories:
    select(@change="filter(selectedCat)" v-model="selectedCat")
      option(value='' selected) Select a Category
      option(v-for="(val, key) in option.getFilterData", :value="key") {{key}}

</template>

<script>
import bemsPlaceCard from './bems-place-card.vue'
import adFeatured from '@/components/ad-featured.vue'
import searchNFilter from '@/components/search-n-filter'

import imagesLoaded from 'vue-images-loaded'
import isotope from 'vueisotope'

export default {
  name: 'cities',
  data() {
    return {
      msg: 'Welcome to Your Vue.js PWA',
      currentLayout: 'masonry',
      selected: null,
      sortOption: 'original-order',
      filterOption: 'show all',
      selectedCat: '',
      option: {
        itemSelector: '.element-item',
        getFilterData: {
          'Show All': function () {
            return true
          },
          'Ghost Towns': function (el) {
            return el.population === 'Ghost Town'
          },
          'Population of 1000+': function (el) {
            return el.population >= 1000
          }
        }
      }
    }
  },
  computed: {
    cities() {
      return this.$store.getters.cities
    }
  },
  components: {
    bemsPlaceCard,
    isotope,
    adFeatured,
    searchNFilter
  },
  created() {
    this.$store.dispatch('loadedCities')
  },
  directives: {
    imagesLoaded
  },
  methods: {
    filter(key) {
      this.$refs.cpt.filter(key)
    },
    layout() {
      this.$refs.cpt.layout('masonry')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

button:focus {
  outline: none;
}

button:hover {
  background: #008080;
}

.deal-container {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 350px;
  min-width: 350px;
  background: #333;
  overflow: hidden;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);
  margin-left: 2em;
}

.deal-title-container {
  background: linear-gradient(#555, #333);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
}

.deal-detail {
  color: #ddd;
  padding: 0.5em;
  line-height: 1.5;
  font-size: 1.5vh;
}

.deal-img-wrapper {
  margin-bottom: 2px;
  border-bottom: 5px solid #555;
  border-top: 5px solid #555;
}

.deal-img-wrapper img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.deal-button-wrapper.left {
  width: 100%;
}

.deal-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: linear-gradient(#555, #333);
  height: 50px;
  bottom: 0px;
  width: 100%;
  background-color: #555;
}

button {
  min-width: 75px;
  margin-left: 1em;
  height: 60%;
  background: linear-gradient(#555, #444);
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);
}
</style>
